// extracted by mini-css-extract-plugin
module.exports = {"benefit_point_container":"BenefitPoint_benefit_point_container__U8SNo"};